export default (function (_ref) {
  var Vue = _ref.Vue;
  Vue.filter('ucfirst', function (value) {
    if (value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  });
});